import { Chip } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import theme from '../../MuiTheme/theme'
import { useStyle } from './Style'
import { StatusProps } from './Type'

export const Status: React.FC<StatusProps> = ({
  className,
  green,
  red,
  blue,
  orange,
  grey,
  text,
  hide,
  wrapText,
  size,
  icon,
}): React.ReactElement => {
  const classes = useStyle({ wrapText: !!wrapText, size: size || 'medium' })

  const renderBackgroundProps = (): string => {
    if (green) {
      return theme.palette.success.light
    }
    if (orange) {
      return theme.palette.warning.light
    }
    if (red) {
      return theme.palette.error.light
    }
    if (blue) {
      return theme.palette.primary.light
    }
    if (grey) {
      return theme.palette.secondary.light
    }
    return theme.palette.common.white
  }

  const renderColorProps = (): string => {
    if (green) {
      return theme.palette.success.main
    }
    if (orange) {
      return theme.palette.warning.main
    }
    if (red) {
      return theme.palette.error.main
    }
    if (blue) {
      return theme.palette.primary.main
    }
    if (grey) {
      return theme.palette.secondary.dark
    }
    return theme.palette.common.white
  }

  const renderIcon = () => {
    return <div style={{ display: 'flex', color: renderColorProps() }}>{icon}</div>
  }

  return (
    <Chip
      className={clsx(
        classes.text,
        className?.container || undefined,
        className?.text || undefined
      )}
      style={{
        color: renderColorProps(),
        backgroundColor: renderBackgroundProps(),
        opacity: hide ? '0' : '1',
      }}
      icon={renderIcon()}
      label={text}
    />
  )
}

export default Status
